var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolationMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Isolation_Mode_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 23,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.445 12.974v.785c0 .185-.017.38-.051.565a1.738 1.738 0 01-.188.534c-.094.17-.213.323-.35.46a1.962 1.962 0 01-.487.332 1.98 1.98 0 01-.563.178 3.73 3.73 0 01-.598.048h-1.844 1.161H4.422h1.161H3.74c-.196 0-.401-.016-.598-.048a1.98 1.98 0 01-.563-.178 2.207 2.207 0 01-.487-.332 1.861 1.861 0 01-.538-.994 3.17 3.17 0 01-.051-.566V13.5 3.152v1.01-1.18-.307-.258c0-.186.017-.38.051-.566.034-.186.094-.364.188-.534.094-.17.213-.323.35-.46a1.96 1.96 0 01.487-.332A1.98 1.98 0 013.14.347C3.338.315 3.543.3 3.74.3h17.469c.197 0 .402.016.598.048.196.033.384.09.563.178.18.09.342.202.487.332a1.86 1.86 0 01.538.994c.034.186.051.38.051.566V12.982v-.008z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Isolation_Mode_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.755.938H2.178v13.564h20.577V.937z",
    fill: "#DEDBCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.532 1.155H2.416V9.24h20.116V1.155z",
    fill: "#40A5D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Isolation_Mode_svg__filter0_d_18043_114735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.531 4.591v-.194-.162c0-.12-.008-.242-.034-.355a1.158 1.158 0 00-.12-.34 1.482 1.482 0 00-.221-.29 1.279 1.279 0 00-.666-.324c-.128-.024-.256-.024-.376-.032H3.842c-.129 0-.257.008-.377.032a1.317 1.317 0 00-.358.113c-.111.057-.214.13-.307.21a1.156 1.156 0 00-.342.63c-.026.122-.026.243-.034.356v1.108-.59 6.216H22.54V4.591h-.009z",
    fill: "#FFB003"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Isolation_Mode_svg__filter1_d_18043_114735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.531 6.322v-.194-.162c0-.121-.008-.243-.034-.356a1.158 1.158 0 00-.12-.34 1.482 1.482 0 00-.221-.29 1.279 1.279 0 00-.666-.324c-.128-.024-.256-.024-.376-.032H3.842c-.129 0-.257.008-.377.032a1.317 1.317 0 00-.358.114c-.111.056-.214.129-.307.21a1.156 1.156 0 00-.342.63c-.026.121-.026.243-.034.356v1.107-.59V12.7H22.54V6.322h-.009z",
    fill: "#40C740"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Isolation_Mode_svg__filter2_d_18043_114735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.531 8.052v-.194-.162c0-.12-.008-.242-.034-.355a1.158 1.158 0 00-.12-.34 1.483 1.483 0 00-.221-.29 1.278 1.278 0 00-.666-.324c-.128-.024-.256-.024-.376-.033H3.842c-.129 0-.257.009-.377.033a1.317 1.317 0 00-.358.113c-.111.057-.214.13-.307.21a1.156 1.156 0 00-.342.63c-.026.122-.026.243-.034.356v1.108-.59 6.216H22.54V8.052h-.009z",
    fill: "#F26D5F"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.195 0v8.949h1.221V2.862v-.194-.162c0-.121.009-.243.034-.356.026-.121.06-.234.12-.34.06-.104.137-.201.222-.29a1.279 1.279 0 01.666-.324c.128-.024.256-.024.376-.032h17.272c.129 0 .257.008.376.032.128.025.248.057.359.114.11.056.213.129.307.21a1.157 1.157 0 01.341.63c.026.122.026.243.035.356V8.957h1.22V0H1.196z",
    fill: "#D9D6CC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Isolation_Mode_svg__filter3_d_18043_114735)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.084 8.084h-.726a4.22 4.22 0 00-.717.057 2.56 2.56 0 00-.683.21c-.026.016-.632.275-1.17 1.067-.41.606-1.212 1.245-2.33 1.245-1.12 0-1.922-.639-2.332-1.245-.572-.84-1.22-1.091-1.17-1.067a2.56 2.56 0 00-.682-.21 4.29 4.29 0 00-.718-.057H1.195v8.084h22.558V8.084h-5.669z",
    fill: "#DEDBCE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Isolation_Mode_svg__filter0_d_18043_114735",
    x: 1.644,
    y: 1.864,
    width: 21.675,
    height: 9.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18043_114735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18043_114735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Isolation_Mode_svg__filter1_d_18043_114735",
    x: 1.644,
    y: 3.594,
    width: 21.675,
    height: 9.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18043_114735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18043_114735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Isolation_Mode_svg__filter2_d_18043_114735",
    x: 1.644,
    y: 5.324,
    width: 21.675,
    height: 9.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18043_114735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18043_114735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Isolation_Mode_svg__filter3_d_18043_114735",
    x: 0.415,
    y: 7.054,
    width: 24.119,
    height: 9.644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18043_114735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18043_114735",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/Isolation_Mode.930fa0ed.svg";
export { SvgIsolationMode as ReactComponent };